<template>
    <cr-app class="cr-app">
        <initial-loading v-if="showInitialLoading" />
        <router-view v-else :key="fullPath"/>
    </cr-app>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router';
import InitialLoading from './components/InitialLoading.vue';
import { useInitialLoadingStore } from './stores/initialLoadingStore';
import { storeToRefs } from 'pinia';

const { showInitialLoading } = storeToRefs(useInitialLoadingStore());

const route = useRoute();
const fullPath = computed(()=> 
{
    return `${route?.fullPath}_${route?.meta?.navigationId}`;
});
</script>